module.exports = __webpack_public_path__ + "static/img/enterprence1.b4afb0a0.png";